import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders, StaticProvider } from '@angular/core';
import { DcEnvironment, type DcEnvironmentCode, getDcEnvironmentFromCode } from '@rma/generic/core/instance';

export const RmaEnvironment = new InjectionToken<DcEnvironment>('RmaEnvironment');

export function provideRmaEnvironment(envCode: DcEnvironmentCode): EnvironmentProviders {
  return makeEnvironmentProviders(provideRmaEnvironmentStatic(envCode));
}

export function provideRmaEnvironmentStatic(envCode: DcEnvironmentCode): StaticProvider[] {
  const env = getDcEnvironmentFromCode(envCode);
  return [{ provide: RmaEnvironment, useValue: env }];
}
